import {
  MeetingRoomGetAllRequest,
  MeetingRoomEnlistRequest,
  MeetingRoomDelistRequest,
  MeetingRoomBatchUpdateRequest,
  MeetingRoomOnUpdateEvent,
  MeetingRoomBatchOnCreateEvent,
  MeetingRoomBatchOnUpdateEvent,
  MeetingRoomBatchCompleteRequest,
  MeetingRoomBatchCreateRequest,
} from "@kalyzee/kast-web-sdk/websocket";
import { createAction } from "@reduxjs/toolkit";

const ACTION_PREFIX = "socket_user_meeting_rooms_";

const socketUserMeetingRoomsActions = {
  getBatchFromMeeting: createAction<MeetingRoomGetAllRequest>(`${ACTION_PREFIX}geAllRoomsFromMeeting`),
  createBatch: createAction<MeetingRoomBatchCreateRequest>(`${ACTION_PREFIX}createBatch`),
  completeBatch: createAction<MeetingRoomBatchCompleteRequest>(`${ACTION_PREFIX}completeBatch`),
  updateBatch: createAction<MeetingRoomBatchUpdateRequest>(`${ACTION_PREFIX}updateBatch`),
  enlistInRoom: createAction<MeetingRoomEnlistRequest>(`${ACTION_PREFIX}enlistInRoom`),
  delistFromRoom: createAction<MeetingRoomDelistRequest>(`${ACTION_PREFIX}delistFromRoom`),

  // Events
  onUpdate: createAction<MeetingRoomOnUpdateEvent>(`${ACTION_PREFIX}on_update`),
  onBatchCreate: createAction<MeetingRoomBatchOnCreateEvent>(`${ACTION_PREFIX}on_room_batch_create`),
  onBatchUpdate: createAction<MeetingRoomBatchOnUpdateEvent>(`${ACTION_PREFIX}on_room_batch_update`),
}

export default socketUserMeetingRoomsActions;
